import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


export default function SavedChats() {
  const [savedChats, setSavedChats] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');


  const navigate = useNavigate();


  useEffect(() => {
    const stored = localStorage.getItem('savedChats');
    if (stored) {
      const sorted = JSON.parse(stored).sort(
  (a, b) => new Date(b.savedAt) - new Date(a.savedAt)
);
setSavedChats(sorted);

    }
  }, []);

  const handleDelete = (id) => {
    const updated = savedChats.filter((msg) => msg.id !== id);
    setSavedChats(updated);
    localStorage.setItem('savedChats', JSON.stringify(updated));
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => alert('Copied to clipboard'));
  };

  const handleExport = () => {
    const content = savedChats
      .map((msg) => `🕒 ${msg.savedAt}\n${msg.text}`)
      .join('\n\n---\n\n');
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'saved_chats.txt';
    a.click();
  };

  const filteredChats = savedChats.filter((msg) =>
    msg.text.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen pl-56 p-6 bg-gray-100">
      <h1 className="text-2xl font-bold mb-4">📂 Saved Conversations</h1>
      <button
  onClick={() => navigate('/chat')}
  className="text-blue-600 hover:underline text-sm mb-4"
>
  ← Back to Chat
</button>


      <input
        type="text"
        placeholder="Search saved chats..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full mb-4 px-3 py-2 border-b border-gray-300 focus:outline-none focus:border-blue-500"
      />

      {savedChats.length === 0 ? (
        <p className="text-gray-600">No saved chats yet.</p>
      ) : (
        <>
          <button
            onClick={handleExport}
            className="mb-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Export All
          </button>

          <div className="space-y-4">
            {filteredChats.length === 0 ? (
              <p className="text-gray-600 italic">No matches.</p>
            ) : (
              filteredChats.map((msg) => {
                const regex = new RegExp(`(${searchTerm})`, 'gi');
                const highlighted = msg.text.split(regex).map((part, i) =>
                  part.toLowerCase() === searchTerm.toLowerCase() ? (
                    <mark key={i} className="bg-yellow-200">{part}</mark>
                  ) : (
                    <span key={i}>{part}</span>
                  )
                );

                return (
                  <div
                    key={msg.id}
                    className="bg-white p-4 rounded shadow-md flex flex-col gap-2"
                  >
                   <p className="text-sm text-gray-600">
  <span className="font-medium">Saved:</span> {new Date(msg.savedAt).toLocaleString()}
</p>


                    <p className="text-gray-800">{highlighted}</p>
                   <div className="flex gap-4 text-sm text-blue-600 items-center">
  <button onClick={() => handleCopy(msg.text)} className="underline">
    Copy
  </button>
  <button
    onClick={() => {
      const shareContent = `🕒 ${new Date(msg.savedAt).toLocaleString()}\n\n${msg.text}`;
      navigator.clipboard.writeText(shareContent);
      alert('Message copied to clipboard! You can now paste it anywhere.');
    }}
    className="underline"
  >
    Share
  </button>
  <button onClick={() => handleDelete(msg.id)} className="underline text-red-600">
    Delete
  </button>
  <button
    onClick={() => {
      const updated = savedChats.map((m) =>
        m.id === msg.id ? { ...m, starred: !m.starred } : m
      );
      setSavedChats(updated);
      localStorage.setItem('savedChats', JSON.stringify(updated));
    }}
    className="text-xl"
    title={msg.starred ? 'Unstar' : 'Star'}
  >
    {msg.starred ? '⭐' : '☆'}
  </button>
</div>

                  </div>
                );
              })
            )}
          </div>
        </>
      )}
    </div>
  );
}